import { render, staticRenderFns } from "./Blazon3.vue?vue&type=template&id=b1757d26&"
import script from "./Blazon3.vue?vue&type=script&lang=js&"
export * from "./Blazon3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports